import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Links({routes, classNames, setEnablePaymentCheckout}) {
  let location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <>
      <div className="hidden md:block">
        <div className="ml-10 flex items-baseline space-x-4">
        {routes.map((route, index) => {
          if (
          route.layout === "/dashboard" ||
          route.layout === "/auth" ||
          route.layout === "/rtl"
        ) {
            
          return(<Link key={index} to={route.layout + "/" + route.path} onClick={()=> setEnablePaymentCheckout(false)}>
           <p
             className={classNames(
             activeRoute(route.path) === true
                 ? "bg-gray-900 text-white"
                 : "text-gray-300 hover:bg-gray-700 hover:text-white",
               "rounded-md px-3 py-2 text-sm font-medium"
             )}
             aria-current={activeRoute(route.path) === true ? "page" : undefined}
           >
             {route.name}
           </p>
           </Link>)
        }
        }
        )}
        </div>
      </div>
    </>
  );
}
